<template>
  <CCol sm="12" lg="12">
    <CRow>
       <CCol sm="6" style="background-size:cover;color:#fff" :style="{ backgroundImage: `url(${backgroundUrl})`}">
        <CCol sm="12" lg="12">
          <img src="../assets/img/Logo.png" width="50px" class="ml-2 mt-2"/> <span class="font-xl ml-2 mt-4">Pickiddo</span>
        </CCol>
        <div class="c-app flex-row align-items-center text-white" style="margin-top:-60px;background:none">
          <CContainer class="p-5">
            <CRow class="justify-content-center">
              <CCol sm="10" lg="10">
                <div class="p-5">
                  <label>
                    <CIcon name="cil-double-quote-sans-left" height="40" />
                  </label>
                  <label class="custom-font-h5">
                    During Covid-19, many student got stuck at home and could not get a good education. Pickiddo gives Student opportunity to find the best teacher that suits their needs.
                    Teachers also can earn some income wile sitting at home.
                  </label>
                  <br />
                  <h5>
                    Pickiddo CEO
                    <CIcon name="cil-check-circle" />
                  </h5>
                </div>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      </CCol>
      <CCol sm="6">
        <CCol sm="12" class="mt-2">
          <CRow>
            <CCol sm="6" lg="6" class="text-left">
              <div>  Back</div>
            </CCol>
            <CCol sm="6" lg="6" class="text-right">
              <div class="small text-muted">Step 01/03</div>Personal Info
            </CCol>
          </CRow>
        </CCol>
        <div style="margin-top:-50px" class="c-app flex-row align-items-center">
          <CContainer class="p-5">
            <CRow class="justify-content-left">
              <CCol sm="10" lg="10">
                <h3 class="text-center">Register Account !</h3>
                <div
                  class="text-muted mb-3 text-center"
                >You need an account in order to start using this platform.</div>
                <CCol sm="12" lg="12">
                  <label>Your FullName *</label>
                  <CInput size="lg" />
                  <label>Email Address *</label>
                  <CInput size="lg" />
                  <label>Create Password *</label>
                  <CInput size="lg" />
                  <input type="checkbox" /> I agree to terms and conditions
                  <CButton style="background:#1565D8" block color="primary" size="lg" class="mt-4">Register Account</CButton>
                  <h5 class="text-center mt-2 mb-2">Or</h5>
                  <CButton block color="light">Register with Google</CButton>
                </CCol>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      </CCol>
    </CRow>
  </CCol>
</template>     
<script>
import backgroundUrl from "../assets/img/bgBuilding.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
export default {
  name: "Login",
  data() {
    return {
      backgroundUrl,
      backgroundUrlTemplate,
    };
  },
};
</script>
